import React from 'react';
import SVGLoader from './SVGLoader';

const defaults = {
  width: 16,
  height: 16,
  viewboxWidth: 12,
  viewboxHeight: 12,
};

export const CallerMicMutedIcon = ({
  width = defaults.width,
  height = defaults.height,
  viewboxWidth = defaults.viewboxWidth,
  viewboxHeight = defaults.viewboxHeight,
  ...rest
}) => {
  return (
    <SVGLoader
      width={width}
      height={height}
      viewboxWidth={viewboxWidth}
      viewboxHeight={viewboxHeight}
      {...rest}
    >
      <path
        d="M3.07617 6.47754C3.56435 6.33777 4.07104 6.2828 4.57448 6.31271C4.82047 6.32732 5 6.5401 5 6.78652V9.39941C5 9.67556 4.77614 9.89941 4.5 9.89941H0.299805C0.253139 9.90036 0.206788 9.89002 0.165039 9.86914C0.123313 9.84824 0.0867856 9.81721 0.0595703 9.7793C0.0318176 9.74214 0.0131795 9.69895 0.00488281 9.65332C-0.00344157 9.60752 -0.00131151 9.56032 0.0117188 9.51562C0.22563 8.79235 0.618646 8.13452 1.1543 7.60352C1.68994 7.07252 2.35108 6.68515 3.07617 6.47754Z"
        fill="currentFill"
      />
      <path
        d="M1.34997 2.84995C1.34997 3.6058 1.65024 4.33069 2.1847 4.86516C2.71917 5.39963 3.44407 5.69989 4.19992 5.69989C4.95577 5.69989 5.68067 5.39963 6.21514 4.86516C6.74961 4.33069 7.04987 3.6058 7.04987 2.84995C7.04987 2.09409 6.74961 1.3692 6.21514 0.83473C5.68067 0.300261 4.95577 0 4.19992 0C3.44407 0 2.71917 0.300261 2.1847 0.83473C1.65024 1.3692 1.34997 2.09409 1.34997 2.84995Z"
        fill="currentFill"
      />
      <g clipPath="url(#clip0_110_11903)">
        <mask
          id="mask0_110_11903"
          maskUnits="userSpaceOnUse"
          x="5"
          y="2"
          width="10"
          height="10"
        >
          <path
            d="M15 12H6.32031C6.40761 11.9634 6.48948 11.9099 6.56055 11.8389L14.8691 3.53027L14.3389 3L5.5 11.8389C5.57105 11.9099 5.65296 11.9634 5.74023 12H5V2H15V12Z"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_110_11903)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.3246 8.11628C10.9732 8.46767 10.4969 8.66557 9.99999 8.66667C9.59891 8.66578 9.2113 8.5367 8.89193 8.30219L11.875 5.32227V6.79167C11.8739 7.28861 11.676 7.76488 11.3246 8.11628ZM8.67538 8.11628L11.875 4.96289V3.875C11.875 3.37772 11.6774 2.90081 11.3258 2.54917C10.9742 2.19754 10.4973 2 9.99999 2C9.50271 2 9.0258 2.19754 8.67417 2.54917C8.32254 2.90081 8.12499 3.37772 8.12499 3.875V6.79167C8.12609 7.28861 8.32399 7.76488 8.67538 8.11628Z"
            fill="currentFill"
          />
          <path
            d="M11.875 4.96289L8.67538 8.11628C8.74317 8.18406 8.8156 8.24614 8.89193 8.30219L11.875 5.32227V4.96289Z"
            fill="currentFill"
          />
          <path
            d="M12.9167 5.33337C12.8061 5.33337 12.7002 5.37727 12.622 5.45541C12.5439 5.53355 12.5 5.63953 12.5 5.75004V6.79171C12.5 7.45475 12.2366 8.09063 11.7678 8.55947C11.2989 9.02832 10.663 9.29171 9.99999 9.29171C9.33694 9.29171 8.70106 9.02832 8.23222 8.55947C7.76338 8.09063 7.49999 7.45475 7.49999 6.79171V5.75004C7.49999 5.63953 7.45609 5.53355 7.37795 5.45541C7.29981 5.37727 7.19383 5.33337 7.08332 5.33337C6.97281 5.33337 6.86683 5.37727 6.78869 5.45541C6.71055 5.53355 6.66665 5.63953 6.66665 5.75004V6.79171C6.66645 7.58854 6.9517 8.35908 7.47071 8.9637C7.98972 9.56832 8.70816 9.96702 9.49582 10.0875C9.51977 10.0914 9.54161 10.1035 9.55758 10.1218C9.57356 10.14 9.58266 10.1633 9.58332 10.1875V11.5834C9.58332 11.6939 9.62722 11.7999 9.70536 11.878C9.7835 11.9561 9.88948 12 9.99999 12C10.1105 12 10.2165 11.9561 10.2946 11.878C10.3728 11.7999 10.4167 11.6939 10.4167 11.5834V10.1875C10.4173 10.1633 10.4264 10.14 10.4424 10.1218C10.4584 10.1035 10.4802 10.0914 10.5042 10.0875C11.2918 9.96702 12.0102 9.56832 12.5293 8.9637C13.0483 8.35908 13.3335 7.58854 13.3333 6.79171V5.75004C13.3333 5.63953 13.2894 5.53355 13.2113 5.45541C13.1331 5.37727 13.0272 5.33337 12.9167 5.33337Z"
            fill="currentFill"
          />
        </g>
        <path
          d="M14.0112 2.3277C14.1577 2.18125 14.3951 2.18125 14.5415 2.3277V2.3277C14.688 2.47414 14.688 2.71158 14.5415 2.85803L5.87948 11.5201C5.73303 11.6665 5.4956 11.6665 5.34915 11.5201V11.5201C5.2027 11.3736 5.2027 11.1362 5.34915 10.9898L14.0112 2.3277Z"
          fill="currentFill"
        />
      </g>
      <defs>
        <clipPath id="clip0_110_11903">
          <rect
            width="10"
            height="10"
            fill="white"
            transform="translate(5 2)"
          />
        </clipPath>
      </defs>
    </SVGLoader>
  );
};

export default CallerMicMutedIcon;
